import { register } from 'larasnap';
import MultiInput from './MultiInput';

register(MultiInput);
